<template>
  <div class="settings-dashboard">
    <!-- Header Section -->
    <b-row>
      <b-col
        cols="12"
        class="mb-2 d-flex align-items-center justify-content-between"
      >
        <div>
          <h1 class="h3 font-weight-bolder mb-0">Settings</h1>
          <span class="text-muted"
            >Manage system configuration and user settings</span
          >
        </div>
        <b-button variant="secondary" to="/">Back to Dashboard</b-button>
      </b-col>
    </b-row>

    <b-row>
      <!-- Configuration Sections -->
      <b-col cols="12">
        <h5 class="font-weight-bold mb-1">Configuration Sections</h5>

        <b-row>
          <b-col
            v-for="(section, index) in configSections"
            :key="index"
            cols="12"
            md="6"
          >
            <b-card
              class="border-0 shadow-sm config-card"
              @click="navigateTo(section.route)"
            >
              <div class="d-flex align-items-start">
                <div
                  class="rounded mr-1 d-flex justify-content-center align-items-center"
                  :style="{
                    backgroundColor: section.bg,
                    minWidth: '42px',
                    height: '42px',
                  }"
                >
                  <feather-icon
                    :icon="section.icon"
                    :style="{ color: section.color }"
                  />
                </div>
                <div class="flex-grow-1">
                  <h6 class="font-weight-bold m-0">{{ section.title }}</h6>
                  <p class="text-muted small m-0 text-description">
                    {{ section.description }}
                  </p>
                  <small class="text-muted">{{ section.stats }}</small>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-card border-variant="secondary">
          <p class="font-weight-bolder">System Status</p>
          <div class="d-flex align-items-center">
            <div
              style="
                width: 12px;
                height: 12px;
                background-color: #4caf50;
                border-radius: 50%;
                display: inline-block;
                margin-right: 8px;
              "
            ></div>
            <span>All systems operational</span>
          </div>
        </b-card>

        <b-card border-variant="secondary">
          <p class="font-weight-bolder">Recent Changes</p>
          <span>Last modified: User permissions - 2 hours ago</span>
        </b-card>

        <b-card border-variant="secondary">
          <p class="font-weight-bolder">Backup Status</p>
          <span>Last backup: Today at 3:00 AM</span>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCol, BRow, BButton, BIcon } from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BIcon,
  },
  data() {
    return {
      configSections: [
        {
          title: "User Management",
          description:
            "Manage admin users, roles, and permissions across the platform",
          stats: "6 Users • 4 Roles",
          icon: "UsersIcon",
          color: "#155dfc",
          bg: "#dbeafe",
          route: "settings-user-management",
        },
        {
          title: "Customer Profiles and Betting Templates",
          description:
            "Configure customer segmentation, risk profiles, and behavioral analytics",
          stats: "12 Segments • 8 Risk Levels",
          icon: "BarChartIcon",
          color: "#9810fa",
          bg: "#f3e8ff",
          route: "settings-customer-profiles-and-betting-templates",
        },
        {
          title: "System Configuration",
          description:
            "Configure platform settings, limits, and operational parameters",
          stats: "15 Categories • 120+ Settings",
          icon: "SettingsIcon",
          color: "#e7000b",
          bg: "#ffe2e2",
          route: "settings-system-configuration",
        },
        {
          title: "Security & Compliance",
          description:
            "Manage security protocols, audit trails, and regulatory compliance",
          stats: "8 Security Policies • 25 Compliance Rules",
          icon: "ShieldIcon",
          color: "#00a63e",
          bg: "#dcfce7",
          route: "settings-security-and-compliance",
        },
        {
          title: "Notifications",
          description:
            "Configure alerts, notifications, and communication preferences",
          stats: "12 Alert Types • 5 Communication Channels",
          icon: "BellIcon",
          color: "#d08700",
          bg: "#fef9c2",
          route: "settings-notifications",
        },
        {
          title: "Marketing and Promo",
          description:
            "Configure System Settings for marketing and promotions default values",
          stats: "Deposit Matches • Boost • MBS",
          icon: "GiftIcon",
          color: "#e8590c",
          bg: "#fff4e6",
          route: "settings-marketing-and-promo",
        },
        {
          title: "Financial Settings",
          description:
            "Manage payment methods, limits, and financial configurations",
          stats: "6 Payment Methods • 20+ Limits",
          icon: "DollarSignIcon",
          color: "#4f39f6",
          bg: "#e0e7ff",
          route: "dashboard",
        },
      ],
    };
  },
  computed: {
    ...mapState("auth", ["user", "permissions"]),
  },
  created() {
    this.checkPermission();
  },

  methods: {
    navigateTo(section) {
      if (!section) return;
      this.$router.push({ name: section });
    },
    addNewUser() {},
    reviewAuditLogs() {},
    updateRiskProfiles() {},
    securityCheck() {},
    checkPermission() {
      this.configSections = [...this.configSections].filter(
        (i) =>
          !(
            this.permissions.role === "none" &&
            i.route === "settings-user-management"
          ) &&
          !(
            this.permissions.server === "none" &&
            i.route === "settings-system-configuration"
          )
      );
    },
  },
};
</script>

<style scoped>
.settings-dashboard {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.config-card {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 10px;
}

.config-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.action-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  margin: -8px;
}

.action-item:hover {
  background-color: #f8f9fa;
}

.activity-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.bg-purple {
  background-color: #8b5cf6 !important;
}

.text-purple {
  color: #8b5cf6 !important;
}

.bg-opacity-10 {
  opacity: 0.1;
}

@media (max-width: 768px) {
  .settings-dashboard {
    padding: 1rem !important;
  }

  .h3 {
    font-size: 1.5rem;
  }
}

@media (max-width: 576px) {
  .activity-item .d-flex {
    align-items: flex-start !important;
  }

  .activity-dot {
    margin-top: 4px;
  }
}

@media (min-width: 1440px) {
  .text-description {
    width: 80%;
  }
}
</style>
